// extracted by mini-css-extract-plugin
export default {"warningMessageWrapper":"style_warningMessageWrapper__LnsvS"};